// Expense types, mirroring ExpenseCategory.ExpenseType on the backend.
// Categories default to NON_VARIABLE, and the reports count uncategorised
// expenses and payroll as NON_VARIABLE too.
export const DEFAULT_EXPENSE_TYPE = 'NON_VARIABLE';

export const EXPENSE_TYPES = [
  { value: 'NON_VARIABLE', label: 'Non-Variable', color: 'blue' },
  { value: 'VARIABLE', label: 'Variable', color: 'orange' },
];

export const expenseTypeOf = (value) =>
  EXPENSE_TYPES.find((type) => type.value === value)
  || EXPENSE_TYPES.find((type) => type.value === DEFAULT_EXPENSE_TYPE);
